import { ActionIcon, Group, Paper, Text, Tooltip } from "@mantine/core"
import { IconHome } from "@tabler/icons-react"
import classes from "./NavbarOptionButton.module.css"
import { WavingHandIcon } from "@/components/generic/WavingHandIcon"
import { CSSProperties } from "react"
import Link from "next/link"

interface NavbarOptionButtonProps {
  isSelected: boolean
  label: string
  icon: typeof IconHome | typeof WavingHandIcon
  href: string
  testID?: string
  styles?: {
    icon?: CSSProperties
  }
}

export function NavbarOptionButton({ isSelected, label, icon: Icon, href, testID, styles }: NavbarOptionButtonProps) {
  return (
    <Group justify="center" align="center">
      <Tooltip
        label={label}
        position="right"
        classNames={{
          tooltip: classes.tooltip,
          arrow: classes.arrow,
        }}
        withinPortal={false}
      >
        <ActionIcon
          data-selected={isSelected}
          component={Link}
          variant={isSelected ? "white" : "transparent"}
          color={isSelected ? "rBackBlue.8" : "gray.3"}
          size="lg"
          href={href}
          radius="md"
          aria-label={label}
          className={classes.actionIcon}
          data-testid={`${testID}-btn`}
        >
          <Icon className={classes.icon} stroke={1.5} style={styles?.icon} />
        </ActionIcon>
      </Tooltip>
    </Group>
  )
}
